<template>
  <div class="form-group required">
    <ValidationProvider
      tag="div"
      :rules="rules"
      :name="name"
      :vid="vid"
      v-slot="{ valid, errors }"
    >
      <div>
        <b-form-group label="Formas de pago">
          <b-form-radio-group
            :id="name"
            v-model="currentValue"
            :options="optionsPaymentMethods"
            :name="name"
            value-field="id"
            text-field="name"
            :disabled="disabled"
            :readonly="readonly"
          >
          </b-form-radio-group>
        </b-form-group>
      </div>
      <b-form-invalid-feedback :state="valid">{{
        errors[0]
      }}</b-form-invalid-feedback>
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";

import {
  BFormInvalidFeedback,
  BFormGroup,
  BFormRadioGroup,
  BFormRadio,
} from "bootstrap-vue";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
// services
import PaymentMethods from "@/plugins/services/payment-methods";

export default {
  name: "PaymentMethodRadioInput",
  components: {
    ValidationProvider,
    BFormInvalidFeedback,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
  },
  props: {
    value: {
      type: Number,
      default: null,
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    vid: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: "text",
    },
    disabled: {
      default: false,
    },
    readonly: {
      default: false,
    },
  },
  data: () => ({
    currentValue: "",
    selected: "",
    optionsPaymentMethods: [],
  }),
  watch: {
    currentValue(val) {
      // allows us to use v-model on our input.
      this.$emit("input", val);
    },
    value(val) {
      if (val) this.currentValue = val;
    },
  },
  mounted() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });

    this.currentValue = this.value;

    this.getPaymentMethods();
  },
  methods: {
    getPaymentMethods(search = null) {
      PaymentMethods.selectAll(search)
        .then((res) => {
          this.optionsPaymentMethods = res.data;
          //desahabilitar el metodo de pago adelanto
          let index = this.optionsPaymentMethods.findIndex(
            (data) => data.id === 6
          );
          this.optionsPaymentMethods[index].disabled = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>